import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Bloco "Parcelas e Pix": troca o conteúdo pelo da nova variante, igual ao product-price.
 *
 * @typedef {object} PaymentInfoRefs
 * @property {HTMLElement} content
 *
 * @extends {Component<PaymentInfoRefs>}
 */
class PaymentInfoComponent extends Component {
  requiredRefs = ['content'];

  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /**
   * @param {Event & { promise?: Promise<{ detail?: { html?: Document | Element, newProduct?: { id: string }, productId?: string } }> }} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        if (detail.newProduct) {
          this.dataset.productId = detail.newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const updated = detail.html.querySelector(
          `payment-info-component[data-block-id="${this.dataset.blockId}"] [ref="content"]`
        );
        if (updated) this.refs.content.replaceWith(updated);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[payment-info] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('payment-info-component')) {
  customElements.define('payment-info-component', PaymentInfoComponent);
}
